import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { PLAN_NAMES, PREDEFINED_PAYMENT_PLANS } from "@Shared/@Utils/constants";
import { isEmpty, reduce } from "lodash";
export const GET_PLAN_FOR_PAGE = "GET_PLAN_FOR_PAGE";
export const IS_USAGE_RESTRICTED = "IS_USAGE_RESTRICTED";
export const GET_USAGE_REMAINING_FOR_PAGE = "GET_USAGE_REMAINING_FOR_PAGE";
export const GET_USAGE_LIMIT_FOR_PAGE = "GET_USAGE_LIMIT_FOR_PAGE";
export const PAYMENT_DETAILS = "PAYMENT_DETAILS";
export const PAYMENT_PLANS = "PAYMENT_PLANS";
export const PAYMENT_METHODS = "PAYMENT_METHODS";
export const SUBSCRIPTIONS_DATA = "SUBSCRIPTIONS_DATA";
export const SUBSCRIPTIONS = "SUBSCRIPTIONS";
export const INVOICES = "INVOICES";
export const PAYER = "PAYER";
export const COUPON = "COUPON";
export const CURRENT_ACCOUNT_PLAN_INTERVAL = "CURRENT_ACCOUNT_PLAN_INTERVAL";
export const HAS_CURRENT_USER_ACTIVE_SUBSCRIPTIONS = "HAS_CURRENT_USER_ACTIVE_SUBSCRIPTIONS";
export const HAS_CURRENT_USER_PAYMENT_METHODS = "HAS_CURRENT_USER_PAYMENT_METHODS";
export const IS_CURRENT_USER_PAYER = "IS_CURRENT_USER_PAYER";
export const IS_CURRENT_USER_SUBSCRIBED = "IS_CURRENT_USER_SUBSCRIBED";
export const SUBSCRIBING_CURRENT_ACCOUNT = "SUBSCRIBING_CURRENT_ACCOUNT";
export const HAS_PAYMENT_ERROR = "HAS_PAYMENT_ERROR";
export const RETRY_PAYMENT_URL = "RETRY_PAYMENT_URL";
const getters = {
  [GET_PLAN_FOR_PAGE]: state => page => {
    return state.accountLimits[page];
  },
  [IS_USAGE_RESTRICTED]: (state, getters, rootState, rootGetters) => page => {
    const accountPlanIsFree = rootGetters["AccountStore/ACCOUNT_PLAN_IS_FREE"];
    if (!accountPlanIsFree) return false;
    if (!page) return false;
    const pagePlan = state.accountLimits.byId[page] || {};
    return pagePlan.usesRemaining <= 0;
  },
  [GET_USAGE_REMAINING_FOR_PAGE]: state => page => {
    const pagePlan = state.accountLimits.byId[page] || {};
    return pagePlan.usesRemaining;
  },
  [GET_USAGE_LIMIT_FOR_PAGE]: state => page => {
    const pagePlan = state.accountLimits.byId[page] || {};
    return pagePlan.limit;
  },
  [PAYMENT_DETAILS]: state => {
    var _state$paymentDetails;
    return (_state$paymentDetails = state.paymentDetails) != null ? _state$paymentDetails : {};
  },
  [PAYMENT_PLANS]: (state, getters) => {
    var _context;
    return _mapInstanceProperty(_context = PREDEFINED_PAYMENT_PLANS()).call(_context, plan => {
      var _getters$PAYMENT_DETA;
      return plan.name !== PLAN_NAMES.FREE ? _objectSpread(_objectSpread({}, plan), {}, {
        amount: (_getters$PAYMENT_DETA = getters[PAYMENT_DETAILS].plans) != null ? _getters$PAYMENT_DETA : plan.amount
      }) : plan;
    });
  },
  [PAYMENT_METHODS]: (state, getters) => {
    var _paymentDetails$strip, _paymentDetails$strip2, _paymentDetails$strip3, _paymentDetails$strip4, _paymentDetails$strip5, _paymentDetails$strip6, _paymentDetails$strip7, _paymentDetails$strip8, _context2;
    const paymentDetails = getters[PAYMENT_DETAILS];
    if (isEmpty((_paymentDetails$strip = paymentDetails.stripe) == null ? void 0 : (_paymentDetails$strip2 = _paymentDetails$strip.sources) == null ? void 0 : _paymentDetails$strip2.data)) return [];
    const defaultCardId = (_paymentDetails$strip3 = (_paymentDetails$strip4 = paymentDetails.stripe) == null ? void 0 : (_paymentDetails$strip5 = _paymentDetails$strip4["default_source"]) == null ? void 0 : _paymentDetails$strip5.id) != null ? _paymentDetails$strip3 : "";
    return (_paymentDetails$strip6 = (_paymentDetails$strip7 = paymentDetails.stripe) == null ? void 0 : (_paymentDetails$strip8 = _paymentDetails$strip7.sources) == null ? void 0 : _mapInstanceProperty(_context2 = _paymentDetails$strip8.data).call(_context2, ({
      id,
      brand,
      exp_month: cardExpMonth,
      exp_year: cardExpYear,
      funding,
      last4,
      country,
      address_line1: line1 = "",
      address_line2: line2,
      address_city: city,
      address_state: province,
      address_zip: postalCode,
      card = {
        brand: "",
        exp_year: null,
        exp_month: null,
        funding: "",
        last4: "",
        country: "",
        address_line1: "",
        address_line2: "",
        address_city: "",
        address_state: "",
        address_zip: ""
      },
      object
    }) => ({
      id,
      cardBrand: brand || card.brand,
      cardExpYear: cardExpYear || card.exp_year,
      cardExpMonth: cardExpMonth || card.exp_month,
      funding: funding || card.funding,
      cardLastFourDigits: last4 || card.last4,
      country: country || card.country,
      address: {
        line1: line1 || card.address_line1,
        line2: line2 || card.address_line2,
        city: city || card.address_city,
        province: province || card.address_state,
        postal_code: postalCode || card.address_zip
      },
      default: id === defaultCardId,
      isEditable: object === "card"
    }))) != null ? _paymentDetails$strip6 : [];
  },
  [SUBSCRIPTIONS_DATA]: (state, getters) => {
    var _getters$PAYMENT_DETA2, _getters$PAYMENT_DETA3, _getters$PAYMENT_DETA4, _subscriptionsData$;
    const subscriptionsData = (_getters$PAYMENT_DETA2 = (_getters$PAYMENT_DETA3 = getters[PAYMENT_DETAILS].stripe) == null ? void 0 : (_getters$PAYMENT_DETA4 = _getters$PAYMENT_DETA3.subscriptions) == null ? void 0 : _getters$PAYMENT_DETA4.data) != null ? _getters$PAYMENT_DETA2 : [];
    return (_subscriptionsData$ = subscriptionsData == null ? void 0 : subscriptionsData[0]) != null ? _subscriptionsData$ : {};
  },
  [SUBSCRIPTIONS]: (state, getters, rootState, rootGetters) => {
    var _getters$PAYMENT_DETA5, _getters$SUBSCRIPTION, _getters$SUBSCRIPTION2, _getters$PAYMENT_DETA7, _subscriptionItemsDat, _subscriptionItemsDat2;
    if (isEmpty((_getters$PAYMENT_DETA5 = getters[PAYMENT_DETAILS].stripe) == null ? void 0 : _getters$PAYMENT_DETA5.subscriptions)) return [];
    const subscriptionItemsData = (_getters$SUBSCRIPTION = (_getters$SUBSCRIPTION2 = getters[SUBSCRIPTIONS_DATA].items) == null ? void 0 : _getters$SUBSCRIPTION2.data) != null ? _getters$SUBSCRIPTION : [];
    const plansByUsername = reduce(subscriptionItemsData, (plans, subscription) => {
      var _subscription$metadat, _subscription$plan$pr, _subscription$plan, _getters$PAYMENT_DETA6, _context3;
      const usernames = _Object$keys((_subscription$metadat = subscription == null ? void 0 : subscription.metadata) != null ? _subscription$metadat : {});
      const subscriptionPlanId = (_subscription$plan$pr = subscription == null ? void 0 : (_subscription$plan = subscription.plan) == null ? void 0 : _subscription$plan.product) != null ? _subscription$plan$pr : "";
      const plan = (_getters$PAYMENT_DETA6 = getters[PAYMENT_DETAILS].stripe) == null ? void 0 : _findInstanceProperty(_context3 = _getters$PAYMENT_DETA6.products).call(_context3, product => product.id === subscriptionPlanId);
      usernames.forEach(username => plans[username] = _objectSpread(_objectSpread({}, plan), subscription.plan));
      return plans;
    }, {});
    const payingForAccounts = (_getters$PAYMENT_DETA7 = getters[PAYMENT_DETAILS].payingForAccounts) != null ? _getters$PAYMENT_DETA7 : [];
    const mainSubscriptionPlanId = (subscriptionItemsData == null ? void 0 : (_subscriptionItemsDat = subscriptionItemsData[0]) == null ? void 0 : (_subscriptionItemsDat2 = _subscriptionItemsDat.plan) == null ? void 0 : _subscriptionItemsDat2.id) || "";
    return _mapInstanceProperty(payingForAccounts).call(payingForAccounts, account => {
      var _plansByUsername$acco;
      const willBeRenewed = !(isEmpty(plansByUsername[account.username]) || getters["HAS_PAYMENT_ERROR"]);
      return _objectSpread(_objectSpread({}, account), {}, {
        willBeRenewed,
        plan: plansByUsername[account.username],
        isCurrentUser: account.username === rootGetters["AccountStore/CURRENT_USER_USERNAME"],
        isCancellable: ((_plansByUsername$acco = plansByUsername[account.username]) == null ? void 0 : _plansByUsername$acco.id) === mainSubscriptionPlanId && willBeRenewed
      });
    });
  },
  [INVOICES]: (state, getters) => {
    var _getters$PAYMENT_DETA8, _getters$PAYMENT_DETA9, _getters$PAYMENT_DETA0;
    return (_getters$PAYMENT_DETA8 = (_getters$PAYMENT_DETA9 = getters[PAYMENT_DETAILS].stripe) == null ? void 0 : (_getters$PAYMENT_DETA0 = _getters$PAYMENT_DETA9.invoices) == null ? void 0 : _getters$PAYMENT_DETA0.data) != null ? _getters$PAYMENT_DETA8 : [];
  },
  [PAYER]: (state, getters, rootState, rootGetters) => {
    const payer = getters[PAYMENT_DETAILS].payer;
    if (isEmpty(payer) || payer === undefined) return {};
    const agent = rootGetters["AgentStore/GET_AGENT"](payer.username);
    return _objectSpread(_objectSpread({}, payer), agent);
  },
  [COUPON]: (state, getters) => {
    var _getters$PAYMENT_DETA1;
    return (_getters$PAYMENT_DETA1 = getters[PAYMENT_DETAILS].coupon) != null ? _getters$PAYMENT_DETA1 : {};
  },
  [CURRENT_ACCOUNT_PLAN_INTERVAL]: (state, getters, rootState, rootGetters) => {
    var _context4, _currentSubscription$, _currentSubscription$2;
    const currentSubscription = _findInstanceProperty(_context4 = getters[SUBSCRIPTIONS]).call(_context4, subscription => subscription.username === rootGetters["AccountStore/CURRENT_USER_USERNAME"]);
    const interval = (_currentSubscription$ = currentSubscription == null ? void 0 : (_currentSubscription$2 = currentSubscription.plan) == null ? void 0 : _currentSubscription$2.interval) != null ? _currentSubscription$ : "month";
    return interval;
  },
  [HAS_CURRENT_USER_ACTIVE_SUBSCRIPTIONS]: (state, getters) => {
    const subscriptions = getters[SUBSCRIPTIONS];
    return subscriptions.length > 1 && subscriptions.some(({
      willBeRenewed,
      isCurrentUser
    }) => willBeRenewed && !isCurrentUser);
  },
  [HAS_CURRENT_USER_PAYMENT_METHODS]: (state, getters) => {
    return getters[PAYMENT_METHODS].length > 0;
  },
  [IS_CURRENT_USER_PAYER]: (state, getters, rootState, rootGetters) => {
    var _getters$PAYER$userna, _context5;
    const currentUsername = rootGetters["AccountStore/CURRENT_USER_USERNAME"];
    const payerUsername = (_getters$PAYER$userna = getters[PAYER].username) != null ? _getters$PAYER$userna : "";
    const subscriptionUsernames = _mapInstanceProperty(_context5 = getters[SUBSCRIPTIONS]).call(_context5, ({
      username
    }) => username);
    return currentUsername === payerUsername || _includesInstanceProperty(subscriptionUsernames).call(subscriptionUsernames, currentUsername);
  },
  [IS_CURRENT_USER_SUBSCRIBED]: (state, getters) => {
    return !!getters[PAYMENT_DETAILS].active;
  },
  [SUBSCRIBING_CURRENT_ACCOUNT]: state => {
    return state.subscribingCurrentAccount;
  },
  [HAS_PAYMENT_ERROR]: (state, getters) => {
    const isPaymentError = ["past_due", "incomplete", "unpaid"];
    const {
      status = ""
    } = getters[SUBSCRIPTIONS_DATA];
    return _includesInstanceProperty(isPaymentError).call(isPaymentError, status) && !getters[IS_CURRENT_USER_SUBSCRIBED];
  },
  [RETRY_PAYMENT_URL]: (state, getters) => {
    var _context6, _lastUnpaidInvoice$ho;
    if (!getters["HAS_PAYMENT_ERROR"]) return "";
    const lastUnpaidInvoice = _findInstanceProperty(_context6 = getters["INVOICES"]).call(_context6, invoice => !invoice.paid);
    return (_lastUnpaidInvoice$ho = lastUnpaidInvoice == null ? void 0 : lastUnpaidInvoice.hosted_invoice_url) != null ? _lastUnpaidInvoice$ho : "";
  }
};
export default getters;